import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';

import Panel from '../commons/Panel';

import AuthenticationStore from '../../stores/AuthenticationStore';
import SelecaoStore from '../../stores/SelecaoStore';
import UIStore from '../../stores/UIStore';

class Apresentacao extends React.Component {
  componentWillMount() {
    UIStore.init('Apresentação', null, null, false);
  }

  render() {
    let isAdmin = AuthenticationStore.hasRole('ADMIN');
    let { pesquisa } = AuthenticationStore.me;
    let rodada = SelecaoStore.rodadaSelecionada;

    return (
      <Panel title="Apresentação" noSpacing>
        <div style={{ display: 'flex' }}>
          <div
            style={{
              padding: '16px',
              width: '50%',
              marginRight: '10px',
              borderRight: '1px solid lightgrey',
            }}
          >
            <p>
              Este relatório é o resultado de pesquisa realizada junto aos
              eleitores maiores de 16 anos residentes nos municípios{' '}
              {pesquisa.uf === 'PR' ? 'do Paraná' : 'de Rondônia'} e aptos para
              o exercício do voto nas <strong>Eleições {pesquisa.ano}</strong>.
            </p>
            <p>
              Com base nos índices levantados, a{' '}
              <strong>Alvorada Pesquisas</strong> organiza projeções de votos
              para cada um dos candidatos. Os índices e números apontados nesta
              síntese servem de orientação, mas não representam valores
              definitivos. Somente a urna poderá indicar os números finais.
            </p>
            <p>
              A pesquisa é peça orientadora da campanha eleitoral, realizando o
              acompanhamento do trabalho de cada um dos candidatos e apontando a
              reação do eleitorado. As tabelas deste relatório mostram a
              evolução da distribuição das cadeiras, rodada após rodada.
            </p>
            <p>
              As tabelas contidas neste relatório são de{' '}
              <strong>uso exclusivo do contratante</strong>, não podendo, em
              nenhuma hipótese, serem divulgadas. A{' '}
              <strong>pesquisa não foi registrada</strong> e a guarda deste
              relatório ficará sob a responsabilidade do contratante, com a
              observância dos dispositivos contidos nos artigos 33, 34, 35 e 96
              da{' '}
              <a
                href="http://www.tse.jus.br/legislacao/codigo-eleitoral/lei-das-eleicoes/lei-das-eleicoes-lei-nb0-9.504-de-30-de-setembro-de-1997#art33-35"
                target="_blank"
                rel="noopener noreferrer"
              >
                Lei nº. 9.504/1997
              </a>
              , bem como das resoluções do TSE{' '}
              <a
                href="http://www.justicaeleitoral.jus.br/arquivos/res-tse-23549-2017-dispoe-sobre-pesquisas-eleitorais-para-as-eleicoes"
                target="_blank"
                rel="noopener noreferrer"
              >
                23.549
              </a>
              e{' '}
              <a
                href="http://www.justicaeleitoral.jus.br/arquivos/res-tse-23547-2017-dispoe-sobre-representacoes-reclamacoes-e-pedidos-de-resposta"
                target="_blank"
                rel="noopener noreferrer"
              >
                23.547
              </a>
              , ambas de 18 de dezembro de 2017, as quais disciplinam,
              respectivamente, para as eleições de {pesquisa.ano}, o registro e
              a divulgação das pesquisas.
            </p>
          </div>
          <div style={{ padding: '16px', width: '50%', marginLeft: '10px' }}>
            <Typography variant="title">Dados Técnicos</Typography>
            <p>Local: {pesquisa.uf === 'PR' ? 'Paraná' : 'Rondônia'}</p>
            <p>Metodologia: pesquisa quantitativa.</p>
            <p>
              Público alvo: eleitores com mais de 16 anos, residentes nos
              municípios.
            </p>
            <p>Amostra: {rodada.amostra} entrevistas.</p>
            <p>
              Período: A coleta de dados foi realizada nos seguintes períodos:
            </p>
            <ul>
              {pesquisa
                ? pesquisa.rodadas
                    .filter(
                      r => (r.aprovada || isAdmin) && r.numero <= rodada.numero
                    )
                    .map(r => (
                      <li key={r.id}>
                        {r.numero}ª consulta:{' '}
                        {moment(r.inicio).format('DD/MM/YYYY')} a{' '}
                        {moment(r.fim).format('DD/MM/YYYY')}.
                      </li>
                    ))
                : ''}
            </ul>
          </div>
        </div>
      </Panel>
    );
  }
}

export default observer(Apresentacao);



// WEBPACK FOOTER //
// ./src/components/apresentacao/index.js